'use client';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { useEffect, useRef } from 'react';
import { useUrlState } from '../hooks';

interface IProps {
  items: JSX.Element[];
  searchParamName?: string;
  currentItem?: number;
}

export const Carousel = ({
  items,
  searchParamName = 'item',
  currentItem: _currentItem = 0,
}: IProps) => {
  const [currentItem, setCurrentItem] = useUrlState(
    searchParamName,
    _currentItem
  );

  const itemsRef = useRef(items.length);

  useEffect(() => {
    if (items.length !== itemsRef.current) {
      itemsRef.current = items.length;
      setCurrentItem(0);
    }
  }, [items]);

  const handleNext = () => {
    setCurrentItem(currentItem === items.length - 1 ? 0 : currentItem + 1);
  };

  const handlePrev = () => {
    setCurrentItem(currentItem === 0 ? items.length - 1 : currentItem - 1);
  };

  if (items.length < 1) {
    return null;
  }

  return (
    <>
      <div className="relative w-full flex items-center justify-center">
        {currentItem !== 0 && (
          <div className="absolute -left-6 top-1/2 -translate-y-1/2 z-10">
            <button
              className="rounded-full border p-2 border-primary-600 bg-white"
              onClick={handlePrev}
            >
              <IconChevronLeft className="text-gray-600" />
            </button>
          </div>
        )}
        <div className="w-full">{items[currentItem]}</div>
        {currentItem !== items.length - 1 && (
          <div className="absolute -right-6 top-1/2 -translate-y-1/2 z-10">
            <button
              className="rounded-full border p-2 border-primary-600 bg-white"
              onClick={handleNext}
            >
              <IconChevronRight className="text-gray-600" />
            </button>
          </div>
        )}
      </div>
      {items.length > 1 && (
        <div className="flex justify-center py-2">
          {items.map((_, index) => (
            <span
              onClick={() => setCurrentItem(index)}
              style={{ width: '40px', height: '8px' }}
              className={`${currentItem === index ? 'bg-primary-700' : 'bg-primary-400'} mx-1 rounded cursor-pointer`}
              key={index}
            />
          ))}
        </div>
      )}
    </>
  );
};
